import $$cookie from './util/cookie.js';
var cookieInfo = {
    $mod: null,
    getC: function() {
        var dataInfo = $$cookie.getCookie('focus-loupan-compare');
        if (dataInfo) {
            dataInfo = dataInfo.split('splitbarbarbarbar');

            for(var i=0; i< dataInfo.length; i++) {
                dataInfo[i] = JSON.parse(dataInfo[i])
            }
        } else {
            dataInfo = [];
        }
        return dataInfo;
    },
    addC: function(data) {
        var dataInfo = this.getC();
        for(var i = 0; i< dataInfo.length; i++) {
            if (dataInfo[i].id == data.id) {
                return;
            }
        }
        dataInfo.push({
            id: data.id,
            name: data.name
        });

        for(var i=0; i< dataInfo.length; i++) {
            dataInfo[i] = JSON.stringify(dataInfo[i])
        }
        $$cookie.setNullPathCookie('focus-loupan-compare', dataInfo.join('splitbarbarbarbar'));
    },
    remoC: function(data) {
        var dataInfo = this.getC();
        for(var i=0; i< dataInfo.length; i++) {
            if (dataInfo[i].id == data.id) {
                dataInfo.splice(i, 1);
            }
        }
        for(var i=0; i< dataInfo.length; i++) {
            dataInfo[i] = JSON.stringify(dataInfo[i])
        }
        $$cookie.setNullPathCookie('focus-loupan-compare', dataInfo.join('splitbarbarbarbar'));
    },
    clearC: function() {
        $$cookie.setNullPathCookie('focus-loupan-compare', '');
    },
    init: function($mod, items) {
        this.$mod = $mod;
        var dataInfo = this.getC();
        if (dataInfo && dataInfo.length > 0) {
            for(var i = 0; i< dataInfo.length; i++) {
                items.append("<li data-id='"+dataInfo[i].id+"'><span class='loupan-name'>"
                + dataInfo[i].name +"</span><span class='delete' node-type='delete'>&#xe8e7;</span></li>");
            }
            $mod.find('[node-type="blank"]').hide();
            $mod.find('[node-type="filled"]').show();
            Event.trigger('shopping-cart', 'change-compare-link');

            setTimeout(function() {
                Event.trigger('lplist-list', 'init-loupan-compare', dataInfo);
                Event.trigger('lplist-list-new', 'init-loupan-compare', dataInfo);
                Event.trigger('loupan-info', 'init-loupan-compare', dataInfo);
                Event.trigger('right-toolbar', 'shopping-cart-count', dataInfo.length);
            }, 1000)

        }
    }
}

export default cookieInfo;



// WEBPACK FOOTER //
// ./~/@front-end/common-module-vm/shopping-cart/cookie.js